/* eslint no-unused-vars: off */
export const selectTikkie = (state) =>
  state.get('paymentRequest').get('tikkie');
export const selectPaymentRequest = (state) =>
  state.get('paymentRequest').get('paymentRequest').toJS();
export const selectPaymentRequestIsLoading = (state) =>
  state.get('paymentRequest').get('paymentRequestIsLoading');
export const selectPaymentRequestErrorMessage = (state) =>
  state.get('paymentRequest').get('paymentRequestErrorMessage');
